export const durationOptions = [
  { id: 0, title: 'Up to 1 minute (60 sec)' },
  { id: 1, title: '1 - 3 minutes' },
  { id: 2, title: '3 - 5 minutes' },
  { id: 3, title: 'Over 5 minutes (fees apply)' },
];

export const firstEditOptions = [
  {
    id: 'overnight',
    label: 'Overnight',
    description: 'must be submitted by 6PM-PST/PDT to receive first edit by 9AM-PST/PDT',
  },
  {
    id: 'same_day',
    label: 'Same-day, additional $50',
    description: 'must be submitted by 10AM-PST/PDT to receive first edit by 4PM-PST/PDT',
  },
];

export const closedCaptions = [
  {
    id: 'sub_in_video',
    label: 'Subtitles in the video file',
  },
  {
    id: 'sub_in_file',
    label: 'Subtitles in a separate file (SRT)',
  },
  {
    id: 'no_sub',
    label: 'No subtitles',
  },
];

// /**
//  * Allowed time for expediting a Video Edit Order
//  * Times are GMT-8 (PST/PDT)
//  */
export const allowedTimeExpediteVideoEdit = {
  start: '16:00:00',
  end: '10:00:00',
};
